import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import editPencilIcon from '../../../assets/img/icons/edit-pencil.svg';
import TableCustomCheckboxDropdownPill from '../../../components/CustomCheckboxDropdown/TableCustomCheckboxDropdownPill';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../../components/NoDataComponent/NoDataComponent';
import TaskActionTooltip from '../../../components/Tooltip/TaskActionTooltip';
import { TableItem } from '../../../styledComponents/ProjectsNew';
import {
  CommonImage,
  Container,
  TableText,
} from '../../../styledComponents/common';
import {
  EditButton,
  ListBody,
  ListContainer,
  ListItem,
  MasterTaskTable,
  SubTaskItem,
  SubTaskList,
  TaskStatusButton,
} from '../../../styledComponents/tasks';
import { EditButtonIcon } from '../tasksStyles';
import Status from 'components/Status/Status';
import BuildinIcon from '../../../assets/img/icons/building.svg';
import ListTodo from '../../../assets/img/icons/list-todo.svg';

const MasterSubTasksList = ({
  masterSubTasksList,
  editMasterSubTask,
  isLoading = false,
  publicZoneList,
}) => {
  const { t } = useTranslation();
  const [openedOfficeDropdown, setOpenedOfficeDropdown] = useState(null);
  const [openedMasterTaskDropdown, setOpenedMasterTaskDropdown] =
    useState(null);

  const handleOfficeDropdownClick = id => {
    if (openedOfficeDropdown === id) {
      setOpenedOfficeDropdown(null);
    } else {
      setOpenedOfficeDropdown(id);
    }
  };

  const handleMasterTaskDropdownClick = id => {
    if (openedMasterTaskDropdown === id) {
      setOpenedMasterTaskDropdown(null);
    } else {
      setOpenedMasterTaskDropdown(id);
    }
  };

  const handleEdit = task => {
    const updatedTask = { ...task, name: task.name };
    editMasterSubTask({ task_id: task.id, ...updatedTask });
  };

  return (
    <Container style={{ paddingBottom: '20px' }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : masterSubTasksList && masterSubTasksList.length > 0 ? (
        <>
          <MasterTaskTable columns="150px 150px 60px 150px 200px 200px 100px 1fr 60px" heading>
            <TableItem>
              <TableText>{t('task_code')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('priority')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('public_zone')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('related_offices')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('related_master_tasks')}</TableText>
            </TableItem>
              <TableItem>
                <TableText>{t('add_to_office_report')}</TableText>
                </TableItem>
            <TableItem>
              <TableText />
            </TableItem>
          </MasterTaskTable>
          
          {masterSubTasksList?.map((task, i) => (
            <MasterTaskTable columns="150px 150px 60px 150px 200px 200px 100px 1fr 50px" key={task.id}>
              <TableItem>
                <TableText>{task.code}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{task.name}</TableText>
              </TableItem>
              <TableItem>
              {task.priority ? <Status status={task.priority} showDot={true} /> : <TableText>-</TableText>}
            </TableItem>
              <TableItem>
                {/* <TableText>
                  {
                    publicZoneList.find(zone => zone.id === task.public_zone_id)
                      ?.name
                  }
                </TableText> */}
                <Status status={publicZoneList.find(zone => zone.id === task.public_zone_id)
                      ?.name} showDot={true} />
              </TableItem>
              <TableItem>
                {task.office && task.office.length > 0 ? (
                  <TableCustomCheckboxDropdownPill
                    opened={openedOfficeDropdown === task.id}
                    options={task.office.map(office => ({
                      label: office.name,
                      value: office.id,
                    }))}
                    selectedOptions={task.office.map(office => ({
                      label: office.name,
                      value: office.id,
                    }))}
                    onClick={() => handleOfficeDropdownClick(task.id)}
                    onChange={() => {}} // Read-only, no changes needed
                    placeholder="related_offices"
                    countLabel="offices"
                    icon={<CommonImage src={BuildinIcon} alt="offices" />}
                  />
                ) : (
                  <TableText>-</TableText>
                )}
              </TableItem>
              <TableItem>
                {task.master_tasks && task.master_tasks.length > 0 ? (
                  <TableCustomCheckboxDropdownPill
                    opened={openedMasterTaskDropdown === task.id}
                    options={task.master_tasks.map(task => ({
                      label: task.name,
                      value: task.id,
                    }))}
                    selectedOptions={task.master_tasks.map(task => ({
                      label: task.name,
                      value: task.id,
                    }))}
                    onClick={() => handleMasterTaskDropdownClick(task.id)}
                    onChange={() => {}} // Read-only, no changes needed
                    placeholder="related_master_tasks"
                    countLabel="master_tasks"
                    icon={<CommonImage src={ListTodo} alt="master tasks" />}
                  />
                ) : (
                  <TableText>-</TableText>
                )}
              </TableItem>

              <TableItem>
                 {/* <TaskStatusButton status = {task.add_to_office_report ? 'added' : 'not_added'}>
                  {task.add_to_office_report ? t('added') : t('not_added')}
                 </TaskStatusButton> */}
                 <Status status={task.add_to_office_report ? 'added' : 'not_added'} showDot={!task.add_to_office_report} showTickIcon={task.add_to_office_report} />
              </TableItem>

              <TableItem>
                <EditButtonIcon onClick={() => handleEdit(task)} title={t('edit_subtask')}>
                  <CommonImage src={editPencilIcon} alt="" />
                </EditButtonIcon>
              </TableItem>
            </MasterTaskTable>
          ))}
        </>
      ) : (
        <NoDataComponent
          title={t('no_master_subtasks_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </Container>
  );
};

export default MasterSubTasksList;
